import { Outlet, useLocation } from "react-router-dom";
import HomeButton from "../core/home_btn";
import { Col, Container, Row } from "react-bootstrap";
import { AppNavBar } from "../core/nav_bar";

export const AppLayout = () => {
  const location = useLocation();
  const isRoot = location.pathname === "/";
  return (
    <div>
      <AppNavBar />
      {!isRoot && (
        <Container className="mt-4">
          <Row className="text-center">
            <Col xs={12} sm={10} md={6} lg={4} className="mx-auto">
              <HomeButton name='Home' route={'/auth'} />
            </Col>
          </Row>
        </Container>
      )}
      <Outlet />
    </div>
  );
};
